import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getAPI } from "../API/ApiService";

const useFetchGlobal = (path, action, header) => {
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      try {
        const response = await getAPI(path);
        if (response?.status === 200) {
          if (header === "Library") {
            dispatch(action(response?.data?.response)); // Update Redux st
          } else if (header === "Special_Project") {
            const newSpecial =
              response?.data?.response?.specialProjectItems?.map((item) => {
                return {
                  ...item,
                  sectionName: item.specialProjectName,
                  sectionId: item.specialProjectId,
                };
              });

            dispatch(
              action({
                internalPageSections: newSpecial,
              })
            );
          } else {
            dispatch(action(response?.data));
          }
        } else {
          dispatch(action([]));
        }
      } catch (e) {
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return { loading };
};

export default useFetchGlobal;
